<template>
  <div class="section-right">
    <h4 class="section-right-title">{{ $t('authorizationmanagement.initialauthorization.operationSectionTitleRight') }}</h4>
    <el-row type="flex" class="section-right-content">
      <el-col :span="12" class="section-right-content-left">
        <div class="section-right-content-label">{{ $t('authorizationmanagement.initialauthorization.goodsName') }}</div>
        <div class="section-right-content-content">{{ $t('authorizationmanagement.initialauthorization.goodsNameContent') }}</div>
      </el-col>
      <el-col :span="12" class="section-right-content-right">
        <div class="section-right-content-label">{{ $t('authorizationmanagement.initialauthorization.version') }}</div>
        <div class="section-right-content-content">{{ $t('authorizationmanagement.initialauthorization.versionNo') }}</div>
      </el-col>
    </el-row>
    <el-row v-for="(item, index) in infolist" :key="index" type="flex" class="section-right-content">
      <el-col :span="12" class="section-right-content-left">
        <div class="section-right-content-label">{{ $t('authorizationmanagement.initialauthorization.'+item.leftName) }}</div>
        <div class="section-right-content-content">{{ item.leftValue }}</div>
      </el-col>
      <el-col :span="12" class="section-right-content-right">
        <div class="section-right-content-label">{{ $t('authorizationmanagement.initialauthorization.'+item.rightName) }}</div>
        <div class="section-right-content-content">{{ item.rightValue }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    infolist: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-right{
    // height: 100%;
    border-left: 1px solid #F3F5F6;
    padding: 20px;
    &-title{
      color: #333;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
    }
    &-content{
      border: 1px dashed #D8D8D8;
      &-left{
        display: flex;
        .section-right-content-label{
          width: 95px;
        }
      }
      &-right{
        display: flex;
        border-left: 1px dashed #D8D8D8;
      }
      &-label{
        width: 80px;
        text-align: right;
        line-height: 20px;
        padding: 9px 0px;
        color: #757575;
      }
      &-content{
        width: calc(100% - 82px);
        line-height: 20px;
        margin:0 12px;
        padding: 9px 0px;
        color: #333;
        font-weight: 600;
        word-break: break-all;
        white-space: unset;
      }
    }
    &-content:nth-of-type(1){
      margin-top: 24px;
    }
    &-content:nth-of-type(n+2){
      border-top: none;
    }
    &-content:nth-last-of-type(1){
      margin-bottom: 10px;
    }
  }
</style>
